import { withPrefix } from 'gatsby'

const withPrefixUrl = addPrefix => obj => {
  return { ...obj, url: addPrefix(obj.url) }
}

const toPrefixUrl = withPrefixUrl(withPrefix)

export { toPrefixUrl }
